// removed by extract-text-webpack-plugin
module.exports = {"wrapper-pull-right":"wrapper-pull-right__3ebda","table-pager":"table-pager__1vpWY","pager-button":"pager-button__xPryT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TablePager/styles.scss
// module id = 2155
// module chunks = 1